module.exports = __webpack_public_path__ + "img/thankyou.f8a1c677.png";